import type { useQueryString } from "~/hooks/use-query-string";

const FILTER_QUERY = [
  "content",
  "spot",
  "purchaseContent",
  "isPurchase",
  "utm_medium",
  "utm_source",
  "utm_campaign",
  "utm_content",
  "aiad_clid",
  "part",
  "resume",
];

export const filteredQueries = (queries: ReturnType<typeof useQueryString>) => {
  const result = Object.fromEntries(
    Object.entries(queries).filter(([key]) => {
      // MEMO : プレイヤーのクエリパラメータ（?season）以外 と 作品末端のクエリパラメータ（?season）以外 を削除する
      if (FILTER_QUERY.includes(key)) return;
      return key;
    })
  );

  return result;
};
